import Vue from 'vue'
import {startDrag} from './drag/drag'

// 拖拽指令
Vue.directive('draggable', {
  bind(el, binding, vnode, oldVnode) {
    startDrag(el.querySelector('.el-dialog__header'), el.querySelector('.el-dialog'), binding.value)
  }
})



// WEBPACK FOOTER //
// ./src/common/VueDirective.js